import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { SUBVENTION_COUNTRY } from 'src/constants/subvention-country';
import { useAppContext } from 'src/context/store/app-provider';
import { getLongestSubventionPlan } from 'src/utils/get-longest-subvention-plan';

export const useGetSubvention = () => {
  const { offers, currency } = useAppContext();
  const country = COUNTRY_NAME_BY_CURRENCY_MAP[currency];

  const longestSubventionPlan = getLongestSubventionPlan(
    offers.installments ?? [],
    currency
  );

  return {
    isSubvention:
      SUBVENTION_COUNTRY.includes(country) && !!longestSubventionPlan,
    longestSubventionPlan,
  };
};
